// extracted by mini-css-extract-plugin
module.exports = {"card":"SkillBox_card__PPDHD","card__front":"SkillBox_card__front__1TU1m","card__back":"SkillBox_card__back__2JjNx"};